import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export function LoyaltyStrip() {
    return (
        <section className="bg-skyblue/25 border-y border-skyblueDeep/20" data-testid="loyalty-strip">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                <div className="flex items-center gap-3 text-inkDark">
                    <Sparkles size={16} className="text-skyblueDeep" />
                    <span className="text-sm">
                        <span className="font-medium">Join the Sukaanyas Circle</span>
                        {" "}— earn Style Coins and unlock tier perks with every order.
                    </span>
                </div>
                <Link
                    to="/loyalty"
                    className="label-eyebrow text-[11px] text-skyblueDeep hover:underline"
                    data-testid="loyalty-strip-cta"
                >
                    Explore programme →
                </Link>
            </div>
        </section>
    );
}
